import sc from './styled';
import { centerPageContainer } from './centerPageContainer.css';

const CenterPageContainer = sc.div(centerPageContainer);

export default CenterPageContainer;
